import * as React from "react";
import { CheckboxEditor } from "../../../../../../react-core/Html/CheckboxEditor";
import { PartLoading } from "../../../../../../react-core/Html/PartLoading";
import { BatchInfoModel } from "../../../../../../Wrap/Models/Domains/Orders/Batch/BatchInfoModel";
import { Order } from "../../../../../../Wrap/Models/Domains/Orders/Order";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { ITableConfig, Table } from "../../../../../Shared/Table/Table";
import { ITypographySectionProps, Typography } from "../../../../../Shared/Typography/Typography";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { batchTypeArraysMap } from "../../Common/Resource/Contents";
import { CancelOrderAction } from "../Action/Action";

interface ICancelOrderProps extends IProcessComponentProps {}

interface ICancelOrderState {
    batchInfo: BatchInfoModel;
    isLoading: boolean;
}

export class CancelOrder extends ProcessComponent<ICancelOrderProps, ICancelOrderState> {
    constructor(props: any) {
        super(props);
        this.state = {
            batchInfo: null,
            isLoading: true,
        };
    }

    isValid() {
        const len = this.props.data.cancel.length;
        if (len == 0) {
            this.props.showErrorMsgPopUp(["No item is cancelled!"], true);
        }
        return len > 0;
    }

    componentDidMount() {
        super.componentDidMount();
        const params = getQueryParameters();
        CancelOrderAction.getBatchInfo(
            {
                BatchId: params["batchid"],
                TransId: 0,
                ClAccountId: params["claccountid"],
                IsConfirmed: false,
            },
            (data) => {
                this.setState({ batchInfo: data, isLoading: false });
                this.props.onChange({ batchInfo: data });
            }
        );
    }

    private getBatchTypographyConfig(data: BatchInfoModel): ITypographySectionProps[] {
        const params = getQueryParameters();
        return [
            { title: "Tax Wrapper", data: params["claccountid"] },
            { title: "Batch ID", data: data.BatchId },
            { title: "Batch type", data: batchTypeArraysMap[data.BatchType] },
        ];
    }

    private getTableConfig(): ITableConfig[] {
        return [
            {
                title: "Cancel",
                key: "",
                render: (data, row: Order, index) => {
                    return (
                        <CheckboxEditor
                            onChange={(v) => {
                                const { data } = this.props;
                                if (v) {
                                    this.props.onChange({ cancel: data.cancel.concat(row.InstrumentCode) });
                                } else {
                                    this.props.onChange({
                                        cancel: data.cancel.filter((ele) => ele == row.InstrumentCode),
                                    });
                                }
                            }}
                            disabled={row.OrderStatus.toLowerCase() != "authorised"}
                        />
                    );
                },
            },
            {
                title: "Instrument",
                key: "Description",
                render: (data, row, index) => {
                    return (
                        <>
                            <p className="mb-0">{data}</p>
                            <p className="mb-0">{row.InstrumentCode}</p>
                        </>
                    );
                },
            },
            {
                title: "Order Value",
                key: "OrderValue",
                render: (data, row, index) => {
                    return data.toFixed(2);
                },
            },

            {
                title: "Order Quantity",
                key: "OrderQuantity",
                render: (data, row, index) => {
                    return data.toFixed(2);
                },
            },
            {
                title: "Status",
                key: "OrderStatus",
                render: (data, row: Order, index) => {
                    return row.OrderStatus;
                },
                thCssWrapper: "cell-left",
                tdCssWrapper: "cell-left",
            },
        ];
    }

    public render(): JSX.Element {
        const { batchInfo, isLoading } = this.state;
        if (isLoading) {return <PartLoading isLoading={isLoading} />;}
        return (
            <>
                <Typography type="common" config={this.getBatchTypographyConfig(batchInfo)} />
                <hr />
                <Table col={this.getTableConfig()} data={batchInfo.InvestmentList} />
            </>
        );
    }
}
